import * as REDUX_TYPES from '../types'

const INITIAL_STATE = {
    mediaDuration: 0,
    hideControls: false,
    muted: true,
    playing: false,
    preview: false,
    userInteracted: false,
    userMutedMedia: true,
    userPausedMedia: false,
    userStartedPlayback: false,
    videoPlaying: false
}

const playerControlsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REDUX_TYPES.PLAYER_CONTROLS.MEDIA_DURATION:
            return {
                ...state,
                mediaDuration: action.mediaDuration,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.HIDE_CONTROLS:
            return {
                ...state,
                hideControls: action.hideControls,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.USER_INTERACTED:
            return {
                ...state,
                userInteracted: action.userInteracted,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.MUTED:
            return {
                ...state,
                muted: action.muted,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.USER_MUTED_MEDIA:
            return {
                ...state,
                userMutedMedia: action.userMutedMedia,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.USER_PAUSED_MEDIA:
            return {
                ...state,
                userPausedMedia: action.userPausedMedia,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.PLAYING:
            return {
                ...state,
                playing: action.playing,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.VIDEO_PLAYING:
            return {
                ...state,
                videoPlaying: action.videoPlaying,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.PREVIEW:
            return {
                ...state,
                preview: action.preview,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.USER_STARTED_PLAYBACK:
            return {
                ...state,
                userStartedPlayback: action.userStartedPlayback,
            }
        case REDUX_TYPES.PLAYER_CONTROLS.RESET:
            return INITIAL_STATE
        default:
            return state
    }
}
export default playerControlsReducer